import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BackNavOverlay.css";

export default function BackNavOverlay() {
  const location = useLocation();
  const navigate = useNavigate();

  // No keyboard shortcuts (removed by design for stability)

  if (location.pathname === "/setup/import" || location.pathname === "/") {
    return null; // Home has no overlay
  }

  return (
    <div className="backnav-overlay">
      {location.pathname === "/setup/preview" && (
        <button onClick={() => navigate("/setup/tag")} className="backnav-btn">
          ← Back to Tag
        </button>
      )}
      {location.pathname === "/live" && (
        <div className="backnav-btn-row">
          <button onClick={() => navigate("/setup/preview")} className="backnav-btn">
            ← Back to Preview
          </button>
          <button onClick={() => navigate("/setup/import")} className="backnav-btn">
            Return Home
          </button>
        </div>
      )}
      {location.pathname === "/setup/tag" && (
        <div className="backnav-btn-row">
          <button onClick={() => navigate("/setup/import")} className="backnav-btn">
            Return Home
          </button>
        </div>
      )}
    </div>
  );
}
